import { styled } from '@mui/material';

export const SBoldText = styled('span')(() => ({
  variant: 'subtitle1',
  fontWeight: 700,
}));

export const SPurpleText = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  variant: 'subtitle1',
  fontWeight: 700,
}));

export const styles = {
  generalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    color: 'common.black',
    height: '100vh',
  },

  warning: {
    mb: '80px',
    maxWidth: '650px',
  },

  backgroundImage: {
    position: 'absolute',
    zIndex: -10,
    maxWidth: '460px',
    height: '100%',
  },

  logo: {
    width: '177.5px',
    height: '32px',
    backgroundColor: 'common.white',
    mt: '55px',
    ml: '55px',
  },

  welcomeText: {
    mt: '34%',
    color: 'common.white',
    ml: '39px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 460px)',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center',
  },

  signInBox: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderRadius: '48px',
    width: '560px',
    height: '395px',
    alignItems: 'center',
    borderColor: 'grey.500',
  },

  iconAndText: {
    display: 'flex',
    ml: '-268px',
    mb: '51px',
    mt: '90px',
  },

  icon: {
    width: '37px',
    height: '37px',
    backgroundColor: 'primary.main',
    mr: '14px',
  },

  text: {
    ml: '-20px',
    mb: '40px',
  },

  signInButton: {
    width: '400px',
  },

  errorGeneralBox: {
    display: 'flex',
    width: 'calc(100% - 460px)',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center',
  },

  errorBox: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderRadius: '48px',
    width: '560px',
    height: '422px',
    alignItems: 'center',
    borderColor: 'grey.50032',
  },

  oopsIcon: {
    width: '80px',
    height: '80px',
    backgroundColor: 'primary.main',
    mt: '80px',
    mb: '24px',
  },

  errorText: {
    mb: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  oopsText: {
    mb: '8px',
  },

  errorButton: {
    width: '200px',
  },
};
